import { t } from "i18next"
import theme from "utils/themeVars"
import { IconText } from "components/custom"

export const PSID_INFO = () => (
  <IconText
    icon="FiInfo"
    iconProps={{
      size: 18,
      color: theme["gray900"],
      showBackground: true,
      style: {
        backgroundColor: theme["gray400"],
        borderRadius: "1rem",
      },
    }}
    titleProps={{ type: "secondary" }}
    title={t(
      "A PSID (unique payment code) will be generated automatically when you submit. Your client uses it to pay via their bank app; further steps may be needed from you."
    )}
  />
)

export const psidAlertStyle = {
  marginTop: 12,
  backgroundColor: theme["gray100"] || "#f5f5f5",
  border: `1px solid ${theme["gray300"] || "#d9d9d9"}`,
}
